import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledSync,
} from "@/shared/context/error-context";
import { useAgreeTermsStates } from "@/features/legal/hooks/use-agree-terms-states";
import { TERMS_URL, PRIVACY_POLICY_URL } from "@/shared/config/constants";
import { ReferenceService } from "@/shared/components/reference/reference-service";


export const useAgreeTerms = () => {
  const referenceService = new ReferenceService();
  const {
    checkedAgreement,
    setCheckedAgreement,
  } = useAgreeTermsStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // 利用規約押下時
  const onClickTerms = () => {
    referenceService.moveFAQLink(TERMS_URL);
  };

  // 個人情報保護方針押下時
  const onClickPrivacyPolicy = () => {
    referenceService.moveFAQLink(PRIVACY_POLICY_URL);
  };

  // チェックボックス押下時の処理
  const onTapAgreement = () => {
    if (checkedAgreement) {
      setCheckedAgreement(false);
    } else {
      setCheckedAgreement(true);
    }
  };

  return {
    checkedAgreement,
    setCheckedAgreement,
    onClickTerms: errorHandledSync(onClickTerms, setError),
    onClickPrivacyPolicy: errorHandledSync(onClickPrivacyPolicy, setError),
    onTapAgreement: errorHandledSync(onTapAgreement, setError),
  };
};
